<template>
  <div class="login-component-block">
    <div class="login-component-block__login-gap">
      <div class="login-component-block__login-gap__title">
        {{ isSignUp ? "Sign Up" : "Log In" }}
      </div>
      <div class="login-component-block__login-gap__subtitle">
        {{ isSignUp ? "Already have an account? " : `Don’t have an account? ` }}
        <span
          class="href-row"
          @click="
            () => {
              isSignUp = !isSignUp;
            }
          "
          >{{ isSignUp ? "Log In" : "Sign Up" }}</span
        >
      </div>
      <div class="login-component-block__login-gap__buttons">
        <div
          class="login-component-block__login-gap__buttons__button _facebook"
          @click="loginByFacebook"
        >
          <div class="icon"></div>
          {{ isSignUp ? "Sign up with Facebook" : "Log in with Facebook" }}
        </div>
        <div
          class="login-component-block__login-gap__buttons__button _google"
          @click="loginByGoogle"
        >
          <div class="icon"></div>
          {{ isSignUp ? "Sign up with Google" : "Log in with Google" }}
        </div>
      </div>

      <div class="login-component-block__login-gap__footer-message">
        <div class="container">
          <div class="row">
            <div class="col">
              <div class="row-label row-center row-color row-labled-checkbox">
                <BaseCheckbox v-model="agreeWithTerms" style="opacity: 0.5">{{
                    `By signing up, you agree to our `
                  }}</BaseCheckbox>
                <span class="href-row" @click="openTerms">terms of service</span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="row-label row-center">
                <span class="row-color" style="opacity: .5">and </span>
                <span class="href-row" @click="openPrivacy">privacy policy</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/app/store/index";
import BaseCheckbox from "@/app/shared/components/base/BaseCheckbox.vue";

export default {
  name: "Login",
  components: { BaseCheckbox },
  data: function () {
    return {
      isSignUp: true,
      agreeWithTerms: true,
    };
  },
  created() {
    if (this.$store.getters.isLoggedIn) {
      let ymUID = this.$cookies.get("_ym_uid");
      this.axios
        .post(
          "/user/getUser",
          { sessionId: this.$store.state.userInfo.sessionId, ymUID: ymUID },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          this.$store.state.userInfo.id = response.data.id;
          this.$store.state.userInfo.firstName = response.data.firstName;
          this.$store.state.userInfo.lastName = response.data.lastName;
          this.$store.state.userInfo.avatar = response.data.avatar;
          this.$store.state.userInfo.stockAccess = response.data.stockAccess;
          this.$store.state.userInfo.isInHouse = response.data.roasupUser;
          this.$store.state.userInfo.isSaveOriginalName =
            response.data.originalName;
          this.$router.push("/");
          //TODO test yandex metrik
          try {
            if (this.$metrika) {
              this.$metrika.userParams({
                Авторизация: response.data.id,
              });
            }
          } catch (e) {
            console.error(e);
          }
        })
        .catch((erorr) => {
          console.error(erorr);
          this.$store.state.userInfo.sessionId = null;
          this.$router.push("/login");
        });
    }
  },
  methods: {
    localLogin() {
      const token = this.$localToken;
      if (!token) {
        alert("Your local token not found! Please set 'VUE_APP_LOCAL_TOKEN'.");
        return;
      }
      this.$store.state.userInfo.sessionId = token;
      this.$cookies.set("sessionId", token);
      this.$router.push("/");
    },
    loginByFacebook() {
      if (!this.checkTermsAgree()) {
        return;

      }
      if (this.$buildType === "local") {
        this.localLogin();
        return;
      }
      let authPointFacebook = `/auth/facebook`;
      let facebookScope = `email`;
      let facebookDevAuthUrl = `https://www.facebook.com/dialog/oauth?client_id=605758379617541&redirect_uri=https://rsz-dev.roasup.com` + authPointFacebook + `&scope=` + facebookScope + `&response_type=code`;
      let facebookProdAuthUrl = `https://www.facebook.com/dialog/oauth?client_id=605758379617541&redirect_uri=https://creative.roasup.com` + authPointFacebook + `&scope=` + facebookScope + `&response_type=code`;
      window.location =
        this.$buildType === "development"
          ? facebookDevAuthUrl
          : facebookProdAuthUrl;
    },
    loginByGoogle() {
      if (!this.checkTermsAgree()) {
        return;
      }
      if (this.$buildType === "local") {
        this.localLogin();
        return;
      }
      let authPointGoogle = `/auth/google`;
      let googleScopeEmail = `https://www.googleapis.com/auth/userinfo.email`;
      let googleScopeProfile = `https://www.googleapis.com/auth/userinfo.profile`;
      //let googleScopeDrive = `https://www.googleapis.com/auth/drive`;
      let googleScopeDriveFile = `https://www.googleapis.com/auth/drive.file`;
      //let googleScopeDriveMetadata = `https://www.googleapis.com/auth/drive.metadata`;
      let googleScope = googleScopeEmail+`%20`+googleScopeProfile+`%20`+googleScopeDriveFile;
        //+`%20`+googleScopeDriveFile+`%20`+googleScopeDriveMetadata;
      let googleDevAuthUrl = `https://accounts.google.com/o/oauth2/auth?client_id=726522728552-2g8t6f5d1ej30994alnreueev8nca0rt.apps.googleusercontent.com&redirect_uri=https://rsz-dev.roasup.com` + authPointGoogle + `&response_type=code&scope=` + googleScope;
      let googleProdAuthUrl = `https://accounts.google.com/o/oauth2/auth?client_id=600674349104-d7pnc2l0mmlp4j7ughs3lnf7032v8vo5.apps.googleusercontent.com&redirect_uri=https://creative.roasup.com` + authPointGoogle + `&response_type=code&scope=` + googleScope;
      window.location =
        this.$buildType === "development"
          ? googleDevAuthUrl
          : googleProdAuthUrl;
    },
    checkTermsAgree() {
      if (!this.agreeWithTerms) {
        alert("You must agree to our terms of service");
      }
      return this.agreeWithTerms;
    },
    openTerms() {
      let termsUrl = `https://roasup.com/terms.html`;
      window.open(termsUrl);
    },
    openPrivacy() {
      let privacyUrl = `https://roasup.com/privacy.html`;
      window.open(privacyUrl);
    }
  },
};
</script>

<style lang="scss">
.login-component-block {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 200%;

  .logo {
    width: 250px;
  }

  .logo svg path {
    fill: red !important;
  }

  &__login-gap {
    width: 484px;
    height: 360px;
    background: $color-gray-3;
    border: 1px solid $color-gray-5;
    box-sizing: border-box;
    border-radius: 8px;
    padding-top: 56px;
    display: flex;
    flex-direction: column;

    &__title {
      width: 100%;

      user-select: none;
      font-family: Roboto;
      font-style: normal;
      font-weight: 500;
      font-size: 24px;
      line-height: 32px;

      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      font-feature-settings: "ss04" on;

      color: $color-font-basic;
    }

    &__subtitle {
      width: 100%;
      padding-top: 12px;

      user-select: none;
      font-family: Roboto;
      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      line-height: 120%;

      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;

      color: $color-font-basic;
      white-space: pre;
    }

    &__buttons {
      width: 100%;
      padding-top: 42px;

      user-select: none;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;

      &__button {
        position: relative;
        width: 298px;
        height: 36px;

        user-select: none;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        text-align: center;

        font-family: Roboto;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 18px;

        background-color: $color-gray-4;
        border-radius: 4px;

        cursor: pointer;

        &:hover {
          background-color: $color-gray-5;
        }

        &._facebook {
          .icon {
            position: absolute;
            left: 9px;
            height: 16px;
            width: 16px;
            background-image: url("~assets/new-icons/facebook-icon.svg");
            background-size: cover;
            background-repeat: no-repeat;
          }
        }

        &._google {
          margin-top: 17px;
          .icon {
            position: absolute;
            left: 9px;
            height: 16px;
            width: 16px;
            background-image: url("~assets/new-icons/google-icon.svg");
            background-size: cover;
            background-repeat: no-repeat;
          }
        }
      }
    }

    &__footer-message {
      width: 100%;
      padding-top: 19px;

      user-select: none;
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 13px;
      line-height: 16px;

      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;

      color: $color-gray-7;
      white-space: pre;
    }
  }
}
</style>
